var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8486 3C20.38 3 20.8486 3.203 21.2546 3.609C21.6606 4.015 21.8636 4.48367 21.8636 5.015V18.984C21.8636 19.5153 21.6606 19.984 21.2546 20.39C20.8486 20.796 20.38 20.999 19.8486 20.999H5.87962C5.34829 20.999 4.87962 20.796 4.47362 20.39C4.06762 19.984 3.86462 19.5153 3.86462 18.984V5.015C3.86462 4.48367 4.06762 4.015 4.47362 3.609C4.87962 3.203 5.34829 3 5.87962 3H19.8486ZM19.8486 5.016H5.87962V18.985H19.8486V5.016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.b927f8a9.svg";
export { ForwardRef as ReactComponent };